import React from "react";
import { Trans } from "react-i18next";

import MoreButton from "components/MoreButton";
import Share from "components/share/Share";
import { isWebbiewShareable, webviewSharePost } from "helpers";
import CatchStoryHiddenLayer from "./layer/CatchStoryHiddenLayer";
import ModalWindow from "components/ModalWindow";


const CatchStoryMoreButton = ({ vod, top, authority, location = "" }) => {

	// 게시글 공유하기
	const handleSharePost = (changeContent, close) => (event) => {
		event.stopPropagation();
		event.nativeEvent.stopImmediatePropagation();

		// 앱내 웹뷰 공유 기능 사용
		if (isWebbiewShareable()) {
			webviewSharePost(vod);
			close();
			return;
		}

		// 공유 팝업 노출
		changeContent(<Share post={vod} close={close} top={top} />);
	};

	return (
		<MoreButton
			trigger={
				<button type="button" className="btn-detail">
					<span></span>
				</button>
			}
			right={0}
			top={top}
		>
			{({ changeContent, close }) => (
				<>
					<button type="button" data-id="share" onClick={handleSharePost(changeContent, close)}>
						<span data-id="share">
							<Trans>공유하기</Trans>
						</span>
					</button>
					{/* 삭제하기 버튼은 권한있어야지만 노출, 홈 > VOD에서는 삭제하기 버튼 미노출 */}
					{authority.is_story_reason_deletable && location !== "home" && (
						<ModalWindow
							onClose={close}
							classNames={{
								modal: "modal_modal_style",
							}}
							trigger={
								<button type="button">
									<span>
										<Trans>삭제하기</Trans>
									</span>
								</button>
							}
							focusTrapped={false}
						>
							{(close) => <CatchStoryHiddenLayer vod={vod} close={close} closeLayer="catchStoryHiddenLayer"/>}
						</ModalWindow>
					)}
				</>
			)}
		</MoreButton>
	);
};

export default CatchStoryMoreButton;
